import { createAction } from 'redux-actions';

export const setUser = createAction('SET_USER');

export const cleanUser = createAction('CLEAN_USER');

export const setAllUsers = createAction('SET_ALL_USERS');

export const logOut = createAction('LOG_OUT');

export const reset = createAction('RESET');

export const changeUserStatus = createAction('CHANGE_USER_STATUS');

export const updateUserStatus = createAction('UPDATE_USER_STATUS');
